module.exports = __webpack_public_path__ + "static/espasol-6089df4f3b2d434d3a3e94061f9f9eb6.jpg";